import React from "react";
import { QueryViewWrap } from "./QueryViewWrap";

const QueryReactView = () => {
  return <QueryViewWrap />;
};
window.QueryReactView = QueryReactView;
